import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
        {
          path: '/',
          component: () => import('@/views/proxyList.vue'),
          beforeEnter: (to, from, next) => {
            if(localStorage.getItem('token')) {
              next();
            }else {
              next('/login');
            }
          }
      },
    ],
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/reg',
    name: 'reg',
    component: () => import('../views/regPage.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/loginPage.vue')
  }
]

const router = createRouter({
  // process.env.BASE_URL
  history: createWebHashHistory(),
  routes
})

export default router
